// Generated from backend/web/src/feature-flags/flag-registry.ts by tools/feature-flags/gen.mjs. Do not edit.

export const POSTHOG_FLAG_DEFAULTS: Readonly<Record<string, boolean>> = {
  plc_program_ingestion_enabled: false,
  heygen_video_enabled: false,
  use_gemini_for_video_call: false,
  use_gladia_for_video_call: false,
  multi_agent_mode_enabled: false,
  restrict_upload_to_internal_users: false,
  qwen35_9b_enabled: false,
  formatting_v2: false,
  jn_translation_enabled: false,
  use_attendee_for_meeting_bot: false,
  kg_admin_apply_proposal_enabled: false,
  sld_parsing_enabled: false,
  explain_video_enabled: false,
  workflow_v4_page_enabled: false,
  workflow_legacy_page_enabled: false,
}

export const POSTHOG_FLAG_VARIANT_DEFAULTS: Readonly<Record<string, string>> = {}

export const POSTHOG_FLAG_VARIANTS: Readonly<Record<string, readonly string[]>> = {}
